module.exports = "/_next/static/images/bg-header-d9817868aed372de38a5b86b78a8dcc8.png.webp";